import { Theme } from "@mui/material";
import { colors } from "../../../../constants/colors";

const styles = {
  backgroundColor: colors.white,
  color: colors.black,
  '& #blog-container': {
    background: colors.white
  },
  '& h1': {
    marginBottom: '2rem'
  },
  '& h2': {
    marginBottom: '1rem',
    marginTop: '2rem'
  },
  '& h3': {
    marginBottom: '0.5rem'
  },
  '& p': {
    marginBottom: '1rem'
  },
  '& ul': {
    marginBottom: '1rem'
  },
  '& #blog-related-articles': {
    '& a': {
      color: colors.black,
      textDecoration: 'none',
      '&:hover': {
        color: colors.secondary
      }
    }
  },
  '@media (min-width: 1024px)': {
    '& h1': {
      marginBottom: '3rem'
    },
    '& #blog-container': {
      background: colors.tertiary
    },
  },
};

const blog1Styles: any = (theme?: Theme) => styles;

export default blog1Styles;